<template>
    <div id="artShop">
        <mobileHeader v-if="isMobile == 'Mobile'"></mobileHeader>
        <Header v-else></Header>
        <backhead :title="titleLabel"></backhead>
        <div class="mainbox app-content" :class="{ Mobileclass: isMobile == 'Mobile' }">
            <div class="hasline">
                <div class="imgtxt">
                    <!-- <img :src="details.image" alt="" class="pic"> -->
                    <div class="txttxt">
                        <div class="con">
                            <h5 class="app-title">{{ details.title }}</h5>
                            <h4 v-if="details.pid == 10">￥{{ details.price }}</h4>
                            <h4 v-else>{{ details.start_time }} {{details.start_time? '-':"" }} {{ details.end_time }}</h4>
                        </div>
                        <p class="content-with-images" v-html="details.content"></p>
                    </div>
                </div>
            </div>
            <!-- <div class="hasline">
                <div class="imgtxt flex">
                    <div class="txttxt">
                        <p>公益活动是指大师傅撒旦撒大苏打实打实夫人分为，范德萨范德萨范德萨分为vv人。第三方的官方热风完成，而非感人肺腑热风分为。公益活动是指大师傅撒旦撒大苏打实打实夫人分为，范德萨范德萨范德萨分为vv人。第三方的官方热风完成，而非感人肺腑热风分为。公益活动是指大师傅撒旦撒大苏打实打实夫人分为，范德萨范德萨范德萨分为vv人。第三方的官方热风完成，而非感人肺腑热风分为。</p>
                    </div>
                    <img src="../assets/img1.png" alt="" class="pic">
                </div>
            </div> -->
        </div>
    </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import { getshowList } from "../utils/gerData";
import { currentLanguage } from "../utils/lang";
import { useRoute } from 'vue-router';
import { backheadTitles, imageurl} from "../utils/i18nLabels";

const route = useRoute();
const isMobile = localStorage.getItem('userAgent')
const titleLabel = computed(() => backheadTitles.details[currentLanguage.value || 'zh'])
const details = ref({});

// 获取列表数据
function getList() {
    let queryParams = {
        id: route.query.id
    }
    getshowList(queryParams).then(res => {
        const data = res.data
        const tdetails = data?.list[0] || {}
        tdetails.image = tdetails?.image ? imageurl + tdetails?.image : undefined
        tdetails.start_time = tdetails?.start_time!='0001-01-01T00:00:00Z' ? tdetails.start_time.slice(0, 4) + '年' + tdetails.start_time.slice(5, 7) + '月' + tdetails.start_time.slice(8, 10) + '日' : ""
        tdetails.end_time = tdetails?.end_time!='0001-01-01T00:00:00Z' ? tdetails.end_time.slice(0, 4) + '年' + tdetails.end_time.slice(5, 7) + '月' + tdetails.end_time.slice(8, 10) + '日' : ""
        details.value = tdetails;
    });
}
getList()

watch(currentLanguage, () => {
    getList()
})
</script>

<style scoped>
#artShop {
    overflow: hidden;
}

.mainbox {
    margin-top: 200px;
    text-align: left;
}

.hasline {
    overflow: hidden;
    padding: 50px 60px;
}

.imgtxt {
    max-width: 814px;
    margin: 0 auto;

    .txttxt {}

    .con {
        margin-bottom: 20px;
        text-align: center;

    }

    h5 {
        font-size: 21px;
        color: #000;
        margin-bottom: 10px;
    }

    h4 {
        font-size: 18px;
        color: #3a3a3a;
        font-weight: normal;
        margin-top: 10px;
    }

    p {
        color: #000;
        font-size: 18px;
        width: 100%;
        word-break: break-all;
        word-wrap: break-word;
        overflow-wrap: break-word;
    }
}

.Mobileclass {
    padding: 0 22px 30px;
    margin-top: 160px;

    .flex {
        display: block;
    }

    .imgtxt {
        width: 100%;
        display: block !important;

        img,
        .txttxt {
            display: block !important;
            width: 100% !important;
        }

        p {
            text-align: center;
        }
    }

    .hasline {
        padding: 0;
    }
}

/* 全局样式来影响v-html内容中的图片 */
:deep(p) img {
    height: auto !important;
    max-width: 100% !important;
}
</style>